async function getSection(section) {
    try {
        const data = await (await fetch(`/pages/filter-swatches`)).text();
        const parser = new DOMParser();
        const nodes = parser.parseFromString(data.toString(), 'text/html').querySelectorAll('.filter-swatches');
        if (!nodes) {
            console.error('No node found in', data);
            return {};
        }
        let swatches = {};
        nodes.forEach(element => {
            let content = (element.textContent || '').trim();
            if (content == '') return;
            content = JSON.parse(content);
            swatches = { ...swatches, ...content };
        });
        return swatches;

    } catch (e) {
        console.log('No swatches found.');
    }

    return {};
}

window.addEventListener('DOMContentLoaded', () => {
    const style = document.createElement('style');
    document.head.appendChild(style);
    const styleEl = style.sheet;
    getSection()
        .then((swatches) => {
            for (const name in swatches) {
                styleEl.insertRule(`.swatch-color[data-color="${name}"] {background-image: url(${swatches[name]})}`);
            }
            if(!Object.keys(swatches).length) style.remove();
        });
});